import {
  getAllDashboardsQuery,
  getDashboardByIdQuery,
  createDashboardMutation,
  updateDashboardMutation,
  deleteDashboardMutation
} from '~graphql/dashboards.graphql'

export default {
  getAllDashboards({ dispatch, state }) {
    return dispatch('getItems', {
      state,
      modelName: 'dashboards',
      loader: 'dashboards:get',
      query: getAllDashboardsQuery,
      resultPath: 'dashboards.nodes'
    })
  },
  getDashboardById({ dispatch, state }, dashboardId) {
    return dispatch('getItemById', {
      id: dashboardId,
      state,
      modelName: 'selectedDashboard',
      loader: 'dashboard:get',
      query: getDashboardByIdQuery,
      resultPath: 'dashboard'
    })
  },
  createDashboard({ dispatch, state }, dashboard) {
    return dispatch('createItem', {
      item: { dashboard },
      state,
      modelName: 'selectedDashboard',
      addTo: ['dashboards'],
      loader: 'dashboard:persist',
      mutation: createDashboardMutation,
      resultPath: 'createDashboard.dashboard'
    })
  },
  updateDashboard({ dispatch, state }, dashboard) {
    return dispatch('updateItem', {
      item: { dashboard },
      state,
      modelName: 'selectedDashboard',
      addTo: ['dashboards'],
      loader: 'dashboard:persist',
      mutation: updateDashboardMutation,
      resultPath: 'updateDashboard.dashboard'
    })
  },
  deleteDashboard({ dispatch, state }, dashboardId) {
    return dispatch('deleteItem', {
      id: dashboardId,
      state,
      modelName: 'selectedDashboard',
      removeFrom: ['dashboards'],
      loader: 'dashboard:delete',
      mutation: deleteDashboardMutation
    })
  },
  setSelectedDashboard({ state, commit }, dashboard) {
    commit('SET_ITEM', {
      item: dashboard,
      state,
      modelName: 'selectedDashboard'
    })
  },
  clearSelectedDashboard({ commit, state }) {
    commit('SET_ITEM', {
      item: {},
      state,
      modelName: 'selectedDashboard'
    })
  }
}
